export const executePost = (url, data) => { return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }); }
  
  const AUTH_HEADER = "Authorization";
  
  export function attachTokenToRequest(token) {
    if (token) {
      setHeaderKey(AUTH_HEADER, `Bearer ${token}`);
    } else {
      setHeaderKey(AUTH_HEADER, "");
    }
  }
  
  let headers = new Headers();
  
  function setHeaderKey(key, value) {
    headers.set(key, value);
  }
  
  export function get(url) {
    return fetch(url, {
      headers: headers
    });
  }
  
  export function GetWithParams(url, data) {
    let query = Object.keys(data)
      .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
      .join('&');
    return fetch(`${url}?${query}`, {
      headers: headers
    });
  }
  
  export function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers
      },
      body: JSON.stringify(body)
    });
  }